import { useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTokenValidation } from '../hooks/useTokenValidation';
import { useSession } from '../context/SessionContext';

export default function TokenLanding() {
  const [searchParams]  = useSearchParams();
  const navigate        = useNavigate();
  const { setJwtToken, setFormAccessId } = useSession();

  // Capture once then immediately remove from URL — keeps the token out of
  // the address bar, browser history, and referrer headers after the first request.
  const tokenRef = useRef<string | null>(searchParams.get('token'));
  const token    = tokenRef.current;

  useEffect(() => {
    window.history.replaceState(null, '', window.location.pathname);
  }, []);

  const { isLoading, isValid, formAccessId, errorCode } = useTokenValidation(token);

  useEffect(() => {
    if (isLoading) return;

    if (isValid && token) {
      setJwtToken(token);
      if (formAccessId) setFormAccessId(formAccessId);
      navigate('/verify', { replace: true });
    } else {
      navigate(`/error?reason=${errorCode ?? 'UNKNOWN_ERROR'}`, { replace: true });
    }
  }, [isLoading, isValid, formAccessId, errorCode, token, navigate, setJwtToken, setFormAccessId]);

  return (
    <div className="token-landing" role="status" aria-live="polite">
      <div className="spinner" aria-label="Validating your access link…" />
      <p>Verifying your access link. Please wait…</p>
    </div>
  );
}
